 
 
 
import monitoring from './monitoring'
import dashboard from './dashboard'
import credits from './credits'
import simManage from './sim-manage'
 
import { createStore } from "vuex"
import { getFormDataFromObject, isObjEmpty, sortArrayByObjProps } from "../js/helper";
import APIMETHODS from "../js/api-methods";
import axios from "axios";
import ApiMethods from "../js/api-methods";
 

let qs = require('qs');

const store = createStore({
	state: {
		IS_LOGGED_IN: false,
		IS_ROOT: false,
		IS_AGENT: false,
		ERROR: null,
		ALERT: null,
		PROMPT: null,
		USER: null,

		//API_VALIDATION_ERROR: null,
		UserInfo: {},
		MajorToken: '',
		MinorToken: '',
		RootToken: '00000000-0000-0000-0000-000000000000',
		Solutions: [],
		Products: [],
		SearchCancelToken: null,
		isRoutablePopupOpened: false,
		isRoutablePopupBigOpened: false,
		POSINFOASSETLIST: {},

		info: {},
		isLoggedIn: false
		//ActiveTab: '',
	},
	mutations: {


		setInfo(state, info){
      state.info = info
    },
    clearInfo(state){
      state.info = {}
    },

		setAuthState(state, auth){
      state.isLoggedIn = auth
    },
		
		SET_ERROR(state, error) {
			state.ERROR = error
		},
		CLEAR_ERROR(state) {
			state.ERROR = null
		},
		SET_ALERT(state, alert) {
			state.ALERT = alert
		},
		SET_PROMPT(state, prompt) {
			state.PROMPT = prompt
		},
		SET_USER(state, user) {
			state.USER = user
		},

		SET_USER_INFO(state, info) {
			state.UserInfo = info;
			//localStorage.USERINFO = JSON.stringify(info);
		},
		CLEAR_USER_INFO(state) {
			state.UserInfo = {};
			localStorage.clear();
		},

		SET_AUTH_STATE(state, auth) {
			state.IS_LOGGED_IN = auth
		},
		SET_IS_ROOT(state, isRoot) {
			state.IS_ROOT = isRoot
		},
		SET_IS_AGENT(state, isAgent) {
			state.IS_AGENT = isAgent
		},
		SET_MAJOR_TOKEN(state, token) {
			state.MajorToken = token
		},
		SET_MINOR_TOKEN(state, token) {
			state.MinorToken = token
		},
		SET_SOLUTIONS(state, solutions) {
			state.Solutions = solutions
		},
		SET_PRODUCTS(state, products) {
			state.Products = products
		},
		SET_SEARCH_CANCEL_TOKEN(state, searchCancelToken) {
			state.SearchCancelToken = searchCancelToken
		},
		SET_ROUTABLE_POPUP_STATE(state, isOpened) {
			state.isRoutablePopupOpened = isOpened
		},
		SET_ROUTABLE_POPUP_BIG_STATE(state, isOpened) {
			state.isRoutablePopupBigOpened = isOpened
		},

		SET_POSINFOASSETLIST(state, data) {
			state.POSINFOASSETLIST = data;
		}
		/*SET_ROUTABLE_POPUP_STATE(state, pageName){
		  state.ActivePage = pageName
		}*/
	},
	getters: {
		isLoggedIn: s => s.isLoggedIn,
		info: s => s.info,
		ERROR: s => s.ERROR,
		ALERT: s => s.ALERT,
		PROMPT: s => s.PROMPT,
		//API_VALIDATION_ERROR: s => s.API_VALIDATION_ERROR,
		IS_LOGGED_IN: s => s.IS_LOGGED_IN,
		IS_ROOT: s => s.IS_ROOT,
		IS_AGENT: s => s.IS_AGENT,


		UserInfo: s => s.UserInfo,

		MajorToken: s => s.MajorToken,
		MinorToken: s => s.MinorToken,
		RootToken: s => s.RootToken,
		Solutions: s => s.Solutions,
		Products: s => s.Products,
		SearchCancelToken: s => s.SearchCancelToken,
		isRoutablePopupOpened: s => s.isRoutablePopupOpened,
		isRoutablePopupBigOpened: s => s.isRoutablePopupBigOpened,
		POSINFOASSETLIST: (state) => state.POSINFOASSETLIST,

	},
	actions: {
		/*async GET_USER_INFO({commit}, query){
		  try {
			let data = new URLSearchParams(query).toString()
			let response = await fetch(APIMETHODS.GET_USER_INFO+'?'+data );
			response = await response.json();
			const getLanguage = () => navigator.userLanguage || (navigator.languages && navigator.languages.length && navigator.languages[0]) || navigator.language || navigator.browserLanguage || navigator.systemLanguage || 'en';
	
			if(response.MajorCode === '000' && !isObjEmpty(response.Data)){
			  response.Data.Locale = getLanguage()
	
			  commit('SET_USER_INFO', response.Data)
	
			  return response.Data
			}else{
			  response.method = 'GET_USER_INFO';
			  commit('SET_ERROR', response)
			  return false
			}
		  } catch (e) {
			if(e && e.response && e.response.data) e.response.data.method = 'GET_USER_INFO';
			commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		  }
		},*/

		async logout({dispatch, commit}) {

		 
      await dispatch('clearAllInfo');
      commit('setAuthState', false)
    },

		async clearAllInfo({dispatch, commit, rootState}){
      try {
        await axios.get(APIMETHODS.LOGOUT, { params: {
            MinorToken: rootState.info.MinorToken,
            deviceToken: localStorage.PUSH_DEVICE_TOKEN,
            mobileToken: localStorage.PUSH_MOBILE_TOKEN,
          } } ).then(async function (response) {

        })
      } catch (e) {
      //  commit('setError', e)
        throw e
      }
      commit('clearInfo');
     // await Vue.nextTick();
    
    },

		async LOGIN({ commit }, params) {
			try {
				const response = await axios.get(APIMETHODS.LOGIN, {
					params: params,
					//headers: { 'Content-Type': 'application/json' }
				});
			

			 
				if(response.data.MajorCode === '000'){
					commit('setInfo', response.data.Data)
				 // await Vue.nextTick();
				//	commit('setAuthState', true)
				 
					localStorage.USERNAME = params.account;
					localStorage.PASSWORD = params.password;
				}else{
					//method name for correct error message
					response.data.method = 'login';

				//	commit('setApiValidationError', response.data)
				 //	await Vue.nextTick();
				//	commit('setAuthState', false)

				}
			
				return response.data
			} catch (e) {
				/*commit('SET_ERROR', e)
				throw e*/
				if (e && e.response && e.response.data) e.response.data.method = 'LOGIN';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async GET_USER_INFO({ commit }, query) {
			try {
				let data = qs.stringify(query)
				const response = await axios.post(ApiMethods.GET_PRE_EDIT_CUSTOMER_INFO, data);
				if (!response.data.MajorCode) {
					commit('SET_USER_INFO', response.data)

					return response.data

				} else {
					response.data.method = 'GET_PRE_EDIT_CUSTOMER_INFO';
					store.commit('SET_ERROR', response.data)
					return false
				}

			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_PRE_EDIT_CUSTOMER_INFO';
				store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async QUERY_CUSTOMERS({ commit }, query) {
			try {
				let data = getFormDataFromObject(query)
				let response = await fetch(APIMETHODS.QUERY_CUSTOMERS, {
					method: "POST",
					body: data,
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'QUERY_CUSTOMERS';
					commit('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'QUERY_CUSTOMERS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async GET_ASSET_LOCATION({ commit }, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.GET_ASSET_LOCATION, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'GET_ASSET_LOCATION';
					commit('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_ASSET_LOCATION';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async GET_ADDRESS_BY_COORDS({ commit }, params) {
			let data = {
				format: 'json',
				addressdetails: '1',
				lat: params.latitude,
				lon: params.longitude,
			}
			try {
				const response = await axios.get(APIMETHODS.GET_ADDRESS_BY_COORDS, {
					params: data,
					//headers: { 'Content-Type': 'application/json' }
				});
				return response.data
			} catch (e) {
				/*commit('SET_ERROR', e)
				throw e*/
				if (e && e.response && e.response.data) e.response.data.method = 'GET_ADDRESS_BY_COORDS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async GET_PLAYBACK_ARR({ commit }, params) {
			// let data = {
			// 	format: 'json',
			// 	addressdetails: '1',
			// 	lat: params.latitude,
			// 	lon: params.longitude,
			// }
			try {
				const response = await axios.get(APIMETHODS.GET_PLAYBACK_ARR_WITHOUTADDRESSES, {
					params: params,
					//headers: { 'Content-Type': 'application/json' }
				});
				return response.data
			} catch (e) {
				/*commit('SET_ERROR', e)
				throw e*/
				if (e && e.response && e.response.data) e.response.data.method = 'GET_PLAYBACK_ARR';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async GET_SOLUTIONS_AND_PRODUCTS({ commit }, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.GET_SOLUTIONS_AND_PRODUCTS, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					if (response.Data && response.Data.Solutions && response.Data.Solutions.length) {
						commit('SET_SOLUTIONS', sortArrayByObjProps(response.Data.Solutions, [{ prop: 'Name', direction: 1 }]))
					}
					if (response.Data && response.Data.Products && response.Data.Products.length) {
						commit('SET_PRODUCTS', sortArrayByObjProps(response.Data.Products, [{ prop: 'Name', direction: 1 }]))
					}
					return response.Data
				} else {
					response.method = 'GET_SOLUTIONS_AND_PRODUCTS';
					commit('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_SOLUTIONS_AND_PRODUCTS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async setInLocalStorage({ commit, dispatch }, query) {
			if (typeof (query) !== 'object' || !query.name || !query.data) {
				console.log('setInStorage: Wrong query parameters!')
				return
			}
			switch (query.name) {
				case 'customerSettings':
					let settings = await dispatch('getFromLocalStorage', query.name);
					const keys = Object.keys(query.data);
					for (const key of keys) {
						settings[key] = query.data[key];
					}
					localStorage.setItem("COM.QUIKTRAK.AGENT.CUSTOMERSETTINGS", JSON.stringify(settings));
					break;

				default:
					console.log('There is no function associated with this name - ' + query.name);
			}
		},
		async getFromLocalStorage({ commit }, name) {
			var ret = false;
			var str = '';
			if (!name) {
				console.log('getFromStorage: Wrong query parameters!')
				return
			}
			switch (name) {
				case 'customerSettings':
					str = localStorage.getItem("COM.QUIKTRAK.AGENT.CUSTOMERSETTINGS");
					ret = str ? JSON.parse(str) : {}
					break;
				case 'assetList':
						str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.ASSETLIST");
					 
						ret = str  ? JSON.parse(str) : {}
					break;

				default:
					//this.dialog.alert('There is no item saved with such name - '+name);
					console.log('There is no item saved with such name - ' + name)
			}

			return ret;
		},

		// async getVideoScreen() {

		// }


	},
	modules: {
 
 
		monitoring,
		dashboard,
		credits,
		simManage,
 
		 
	}
})

export default store